/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsEnergySlash: {
  name: 'energy-slash';
  data: string;
} = {
  name: 'energy-slash',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.49 1.098a.5.5 0 0 0-.906-.375l-2 3a.5.5 0 0 0 .832.554l.598-.897-.504 2.522A.5.5 0 0 0 8 6.5h4.066l-.815 1.223a.5.5 0 0 0 .832.554l1.333-2A.5.5 0 0 0 13 5.5H8.61l.88-4.402Zm-4.74 7.18a.5.5 0 0 0-.833-.555l-1.333 2A.5.5 0 0 0 3 10.5h4.39l-.88 4.402a.5.5 0 0 0 .906.375l2-3a.5.5 0 1 0-.832-.554l-.598.897.504-2.522A.5.5 0 0 0 8 9.5H3.934l.815-1.223ZM2.353 1.645a.5.5 0 1 0-.708.708l12 12a.5.5 0 0 0 .708-.708l-12-12Z" fill="currentColor"/></svg>`,
};
